module.exports = __webpack_public_path__ + "static/media/pharmacy-award-img.8d1e8f90.png";